import { array, number, object, string } from '@gogame/schemas';

import {
  ENTRIES,
  PARTNER_AUDIENCE,
  ACCOUNT,
  CAMPAIGNS,
  ADSETS,
  NAME,
} from './constants';

export const validationSchema = object({
  [ENTRIES]: array(object()).required('Entries in required'),
});

export const baseLookalikeTargetingValidationSchema = object({
  [PARTNER_AUDIENCE]: number().required('Partner Audience in required'),
});

export const baseCampaignBasedLookalikeTargetingValidationSchema = object({
  [NAME]: string().required('Name is required'),
  [ACCOUNT]: string().required('Partner account  is required'),
  [CAMPAIGNS]: array(string()).required('Partner campaign  is required'),
  [ADSETS]: array(string()),
});
